import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetContractQuery } from '../../api/contractSlice';
import LoadingIndicator from '../LoadingIndicator';
import { Stack, Typography } from '@mui/material';
import { formatDateShortMonthDayYear } from '../../utils/dateUtils';
import { theme } from '../../theme';
import ContractHospitals from './ContractSections/ContractHospitals';

function Contract() {
    const { contractId } = useParams();
    const { data: contract, isLoading: isContractLoading, isError: isContractError } = useGetContractQuery(contractId);

    // display rebates
    // each rebate has its items, and its periods, highlight current period
    // edit rebate button
    // edit items
    // edit periods

    if (isContractLoading) {
        return <LoadingIndicator variant='contract' />;
    } else if (isContractError) {
        return (
            <Stack alignItems='center' py={6}>
                <Typography variant='normal' sx={{ fontSize: '14px', color: 'error.main' }}>
                    Failed to load contract details.
                </Typography>
            </Stack>
        );
    }

    return (
        <Stack>
            <Stack
                spacing={0.5}
                px={4}
                pb={1}
                sx={{
                    backgroundColor: theme.palette.background.white,
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    top: 64,
                    position: 'sticky',
                    zIndex: 5,
                }}
            >
                <Typography variant="heavy" fontSize='18px'>
                    {contract?.name ?? `Contract ${contractId}`}
                </Typography>
                <Stack direction='row' spacing={3} flexWrap='wrap'>
                    <Typography variant='normal' sx={{ fontSize: '13px', color: 'subtext.main' }}>
                        Vendor: <Typography component='span' variant='heavy' sx={{ fontSize: '13px' }}>{contract?.vendor?.name ?? '—'}</Typography>
                    </Typography>
                    <Typography variant='normal' sx={{ fontSize: '13px', color: 'subtext.main' }}>
                        Start Date: <Typography component='span' variant='heavy' sx={{ fontSize: '13px' }}>{formatDateShortMonthDayYear(contract?.start_date)}</Typography>
                    </Typography>
                    <Typography variant='normal' sx={{ fontSize: '13px', color: 'subtext.main' }}>
                        End Date: <Typography component='span' variant='heavy' sx={{ fontSize: '13px' }}>{formatDateShortMonthDayYear(contract?.end_date)}</Typography>
                    </Typography>
                </Stack>
            </Stack>

            {/* contract hospitals */}
            <Stack spacing={2} px={{ xs: 2, md: 4 }} py={3}>
                <ContractHospitals contract={contract} />
            </Stack>
        </Stack>
    );

}

export default Contract;